import { Pill } from '@iwoca/orion';
import { PERMISSION_LABELS } from './PermissionsCell.helpers';
import styles from './PermissionsCell.module.css';
import { TPermissions } from './PermissionsCell.types';

type TProps = { permissions: TPermissions };

export const PermissionsCell = ({ permissions }: TProps) => {
  const grantedPermissions = PERMISSION_LABELS.filter(
    (permission) => permissions[permission.key],
  );

  return (
    <div className={styles.cell}>
      {grantedPermissions.map((permission) => (
        <Pill key={permission.key} variant="london" size="small">
          <span className={styles.pillContent}>
            <permission.Icon className={styles.pillIcon} aria-hidden />
            {permission.label}
          </span>
        </Pill>
      ))}
    </div>
  );
};
